<template>
<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.0977 9.65918L4.59766 9.65918" stroke="#773DBD" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9.84766 14.9092L4.59766 9.65918L9.84766 4.40918" stroke="#773DBD" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
